import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthFacade } from '@piqet-angular/data';
import { MenuService } from 'libs/features/src/lib/menu/menu.service';
import { CookieService } from 'ngx-cookie-service';
import { RedirectService } from '../../service/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  isLoggedIn!: boolean;

  constructor(
    private router: Router,
    public authFacade: AuthFacade,
    private menu: MenuService,
    private cookieService: CookieService,
    private redirectService: RedirectService
  ) {
    this.authFacade.isLoggedIn$.subscribe((isLoggedIn: boolean) => {
      this.isLoggedIn = isLoggedIn || this.cookieService.get('token') ? true : false;
    });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isFlag = this.cookieService.get('forceResetPasswordDisable');
    if (isFlag === 'false') {
      this.router.navigate(['/secure-password']);
    } else if (!this.isLoggedIn) {
      this.menu.clearMenu();
      // Store the intended URL for redirect after login
      if (!state.url.includes('project-detail-report')) {
        this.redirectService.setRedirectUrl(state.url);
      }
      this.router.navigate(['/login']);
    }
    return this.isLoggedIn;
  }
}
